import { IUser } from '../models/entities/user.models';

export const getUserFullName = (user: IUser): string => [
  user.user_info.passport.sur_name,
  user.user_info.passport.name,
  user.user_info.passport.patronymic,
]
  .join(' ')
  .trim();
